import { initializeApp } from "firebase/app";
import {
    initializeAuth,
    GoogleAuthProvider,
    browserLocalPersistence,
    browserSessionPersistence,
    indexedDBLocalPersistence,
    browserPopupRedirectResolver,
} from "firebase/auth";

// Firebase configuration from environment variables or your values
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// localStorage first: the SDK keeps a stored user in the first store it finds one in and watches
// that store for other tabs. IndexedDB is last only to rescue a user an old-build tab left there.
// Nothing moves a sessionStorage ("Remember me" off) user out of its tab.
const auth = initializeAuth(app, {
    persistence: [
        browserLocalPersistence,
        browserSessionPersistence,
        indexedDBLocalPersistence,
    ],
    popupRedirectResolver: browserPopupRedirectResolver,
});

// Providers for social authentication
export const googleProvider = new GoogleAuthProvider();

export { auth };
export default app;
